import { List } from '../List'
import { getFormatDate } from '../../scripts'

export class PeriodParent extends List {
  constructor(obj) {
    super(Period, obj)
  }
}

export class Period {
  constructor(obj) {
    this.id = obj?.id || null
    this.fromDate = obj?.fromDate || null
    this.toDate = obj?.toDate || null
    this.blockDate = obj?.blockDate || null
    this.quarter = obj?.quarter || null
    this.year = obj?.year || null
    this.period = (obj && getFormatDate(obj?.fromDate) + ' - ' + getFormatDate(obj?.toDate)) || null
  }

  get fullName() {
    return `${this.quarter?.name} ${this.year?.year} г.`
  }

  getForAPI() {
    return {
      id: this.id,
      newBlockDate: this.blockDate,
      newToDate: this.toDate
    }
  }
}
